import React from 'react'
import PropTypes from 'prop-types'
import HTMLContent from '../html-content/html-content'
import AmazonLink from './../amazon-link/amazon-link'
import Youtube from './../youtube/youtube'
import ProsCons from './../pros-cons/pros-cons'
import ImageGallery from './../image-gallery/image-gallery'
import { titleToId } from '../../utils'
import Stars from "../stars/stars";
import Featured from "../featured/featured";
import './product.scss'

class Product extends React.Component {

  render() {
    const product = this.props.product;
    const galleryImages = [
      {
        image_url: product.image,
        image_alt: product.product_name
      }, ...product.image_gallery
    ].filter((item) => item)

    return (
      <div className="product" key={product.product_name}>

        <div className="product__title-wrap">
            <h3 className="product__title" id={titleToId(product.title)}>{product.title}</h3>
            {product.featured ? <span className="product__featured"><Featured featured={product.featured} /></span> : null}
        </div>
        {product.rating ? <div className="product__rating">
          <span className="product__rating-text">Our rating:</span>
          <Stars rating={product.rating} isWithNumber />
        </div> : null}

        <div className="product__gallery">
          <ImageGallery images={galleryImages} />
        </div>
        <div className="product__buy-btn">
          <AmazonLink
            isBlack
            link={product.amazon_link}
            title="View on Amazon"
            productName={product.product_name}
          />
        </div>
        <div className="product__body">
          <HTMLContent content={product.body} />
        </div>
        {product.youtube ? <Youtube videoId={product.youtube} /> : null}
        <ProsCons pros={product.prons} cons={product.cons} />

        <hr className="product__separator" />
      </div>
    )
  }
}

Product.propTypes = {
  product: PropTypes.object,
}

export default Product



// WEBPACK FOOTER //
// ./src/components/products-list/product.js